export const CARD_ICONS: Record<string, string> = {
    'Master Card': 'icon-tfw-mastercard .path4',
    'Visa': 'icon-tfw-visa',
    'Discover': 'icon-tfw-discover',
    'Amex': 'icon-tfw-amex',
};

export const month = [
    {
        id: '01',
        label: 'January'
    },
    {
        id: '02',
        label: 'February'
    },
    {
        id: '03',
        label: 'March'
    },
    {
        id: '04',
        label: 'April'
    },
    {
        id: '05',
        label: 'May'
    },
    {
        id: '06',
        label: 'June'
    },
    {
        id: '07',
        label: 'July'
    },
    {
        id: '08',
        label: 'August'
    },
    {
        id: '09',
        label: 'September'
    },
    {
        id: '10',
        label: 'October'
    },
    {
        id: '11',
        label: 'November'
    },
    {
        id: '12',
        label: 'December'
    }
];

export const statesList = [
    {
        description: 'Alabama',
        id: 'AL'
    },
    {
        description: 'Alaska',
        id: 'AK'
    },
    {
        description: 'Alberta',
        id: 'AB'
    },
    {
        description: 'American Samoa',
        id: 'AS'
    },
    {
        description: 'Arizona',
        id: 'AZ'
    },
    {
        description: 'Arkansas',
        id: 'AR'
    },
    {
        description: 'British Columbia',
        id: 'BC'
    },
    {
        description: 'California',
        id: 'CA'
    },
    {
        description: 'Colorado',
        id: 'CO'
    },
    {
        description: 'Connecticut',
        id: 'CT'
    },
    {
        description: 'Delaware',
        id: 'DE'
    },
    {
        description: 'District Of Columbia',
        id: 'DC'
    },
    {
        description: 'Federated States Of Micronesia',
        id: 'FM'
    },
    {
        description: 'Florida',
        id: 'FL'
    },
    {
        description: 'Georgia',
        id: 'GA'
    },
    {
        description: 'Guam',
        id: 'GU'
    },
    {
        description: 'Hawaii',
        id: 'HI'
    },
    {
        description: 'Idaho',
        id: 'ID'
    },
    {
        description: 'Illinois',
        id: 'IL'
    },
    {
        description: 'Indiana',
        id: 'IN'
    },
    {
        description: 'Iowa',
        id: 'IA'
    },
    {
        description: 'Kansas',
        id: 'KS'
    },
    {
        description: 'Kentucky',
        id: 'KY'
    },
    {
        description: 'Louisiana',
        id: 'LA'
    },
    {
        description: 'Maine',
        id: 'ME'
    },
    {
        description: 'Manitoba',
        id: 'MB'
    },
    {
        description: 'Marshall Islands',
        id: 'MH'
    },
    {
        description: 'Maryland',
        id: 'MD'
    },
    {
        description: 'Massachusetts',
        id: 'MA'
    },
    {
        description: 'Michigan',
        id: 'MI'
    },
    {
        description: 'Minnesota',
        id: 'MN'
    },
    {
        description: 'Mississippi',
        id: 'MS'
    },
    {
        description: 'Missouri',
        id: 'MO'
    },
    {
        description: 'Montana',
        id: 'MT'
    },
    {
        description: 'Nebraska',
        id: 'NE'
    },
    {
        description: 'Nevada',
        id: 'NV'
    },
    {
        description: 'Newfoundland and Labrador',
        id: 'NL'
    },
    {
        description: 'New Brunswick',
        id: 'NB'
    },
    {
        description: 'New Hampshire',
        id: 'NH'
    },
    {
        description: 'New Jersey',
        id: 'NJ'
    },
    {
        description: 'New Mexico',
        id: 'NM'
    },
    {
        description: 'New York',
        id: 'NY'
    },
    {
        description: 'Northwest Territories',
        id: 'NT'
    },
    {
        description: 'North Carolina',
        id: 'NC'
    },
    {
        description: 'North Dakota',
        id: 'ND'
    },
    {
        description: 'Northern Mariana Islands',
        id: 'MP'
    },
    {
        description: 'Nova Scotia',
        id: 'NS'
    },
    {
        description: 'Nunavut',
        id: 'NU'
    },
    {
        description: 'Ohio',
        id: 'OH'
    },
    {
        description: 'Oklahoma',
        id: 'OK'
    },
    {
        description: 'Ontario',
        id: 'ON'
    },
    {
        description: 'Oregon',
        id: 'OR'
    },
    {
        description: 'Palau',
        id: 'PW'
    },
    {
        description: 'Pennsylvania',
        id: 'PA'
    },
    {
        description: 'Prince Edward Island',
        id: 'PE'
    },
    {
        description: 'Puerto Rico',
        id: 'PR'
    },
    {
        description: 'Quebec',
        id: 'QC'
    },
    {
        description: 'Rhode Island',
        id: 'RI'
    },
    {
        description: 'Saskatchewan',
        id: 'SK'
    },
    {
        description: 'South Carolina',
        id: 'SC'
    },
    {
        description: 'South Dakota',
        id: 'SD'
    },
    {
        description: 'Tennessee',
        id: 'TN'
    },
    {
        description: 'Texas',
        id: 'TX'
    },
    {
        description: 'Utah',
        id: 'UT'
    },
    {
        description: 'Vermont',
        id: 'VT'
    },
    {
        description: 'Virgin Islands',
        id: 'VI'
    },
    {
        description: 'Virginia',
        id: 'VA'
    },
    {
        description: 'Washington',
        id: 'WA'
    },
    {
        description: 'West Virginia',
        id: 'WV'
    },
    {
        description: 'Wisconsin',
        id: 'WI'
    },
    {
        description: 'Wyoming',
        id: 'WY'
    },
    {
        description: 'Yukon',
        id: 'YT'
    },
];

export const commonInputStyleProps = {
    h: '36px',
    padding: '6px 12px',
    borderColor: 'input.border',
    borderRadius: '4px',
    bg: 'background.main',
    _hover: { borderColor: 'input.border' },
};

export const changePasswordInputStyleProps = {
    h: '36px',
    padding: '6px 12px',
    borderColor: 'input.border',
    borderRadius: '4px',
    bg: 'background.modal',
    _hover: { borderColor: 'input.border' },
};

export const otherInputStyleProps = {
    h: '36px',
    border: '1px solid',
    borderColor: 'input.border',
    borderRadius: '4px',
    bg: 'background.main',
    _hover: { borderColor: 'input.border', },
};

export const commonPlaceholderProps = {
    textStyle: 'body2',
    color: 'input.placeholder',
};

export const submitButtonProps = {
    w: '63%',
    h: '36px',
    borderRadius: '2px',
    padding: '8px',
    _hover: { bg: 'brand.tertiary' },
    _active: { border: '2px solid', borderColor: 'button.blue', bg: 'brand.tertiary' },
    bg: 'brand.lightTertiary'
};

export const modalButtonProps = {
    h: '36px',
    bg: 'background.main',
    border: '1px solid',
    borderColor: 'button.blue',
    borderRadius: '2px',
    padding: '8px',
    _hover: { bg: 'background.main' },
    _active: { border: '2px solid', borderColor: 'button.blue' },
};

export const emailFormButtonProps = {
    h: '36px',
    w: { base: '100%', sm: '126px' },
    borderRadius: '2px',
    padding: '8px',
    _hover: { bg: 'brand.tertiary' },
    _active: { bg: 'brand.tertiary', border: '2px solid', borderColor: 'brand.tertiary' },
}

export const loginFormMainContainerProps = {
    color: 'text.grey',
    padding: { base: '16px', sm: '40px 32px' },
    gap: { base: '40px', sm: '16px' },
    bg: { base: 'brand.secondary', sm: 'brand.secondary' },
    justifyContent: 'space-between',
}

export const formMainContainerCommonProps = {
    padding: { base: '16px', sm: '30px 42px' },
    gap: '24px',
    bg: { base: 'brand.secondary', sm: 'brand.secondary' },
    color: 'text.grey',
}

export const fpEmailFormProps = {
    padding: { base: '16px', sm: '30px 42px' },
    bg: { base: 'brand.secondary', sm: 'brand.secondary' },
    color: 'text.grey',
    justifyContent: 'center',
}

export const cpLoginFormMainContainerProps = {
    w: '100%',
    gap: '24px',
    bg: 'background.modal',
    color: 'text.grey',
    border: '1px solid',
    borderColor: 'common.grey05',
    borderRadius: '4px',
}

export const cpLoginFormHeaderProps = {
    alignItems: 'center',
    borderBottom: '1px solid',
    borderColor: 'common.grey05',
    borderRadius: '4px',
    padding: '16px',
    justifyContent: 'space-between',
};

export const cpLoginFormFooterProps = {
    padding: '16px',
    borderTop: '1px solid',
    borderColor: 'common.grey05',
    borderRadius: '4px',
    justifyContent: 'flex-end',
}

export const renderInstructionsProps = {
    p: { sm: '0 16px 0 50px' },
    borderLeft: { sm: '1px solid' },
    borderColor: { sm: 'border.coolGrey' },
    gap: '24px',
    w: 'max-content',
}

export const radioButtonStyle = {
    borderColor: 'button.blue',
    borderWidth: "2px",
    _checked: {
        _before: {
            content: '""',
            display: "block",
            width: "8px",
            height: "8px",
            backgroundColor: "button.blue",
            borderRadius: "full",
        },
    },
    _disabled: {
        borderColor: 'border.grey',
    }
};

export const checkboxStyle = {
    borderColor: 'button.blue',
};

export const amountInputProps = {
    h: '36px',
    w: { base: '120px', sm: '150px' },
    borderRadius: '4px',
    borderColor: 'input.border',
    bg: 'brand.secondary',
    _hover: { borderColor: 'input.border', },
    _focus: { border: 'none' },
};

export const payRentMainContainerProps = {
    bg: { base: 'brand.secondary', sm: 'brand.secondary' },
    color: 'text.grey',
    padding: { base: '16px 8px', sm: '40px 32px' },
};
export const payRentMoveInContainerWidth = {
    base: '100%', sm: '640px', md: '885px'
};

export const tableThProps = {
    padding: '12px 6px',
    verticalAlign: 'center',
};

export const innerTextStyles = {
    textStyle: 'body3',
    fontWeight: '700',
};
export const loaderStyles = {
    width: '100%',
    height: '64vh',
    justifyContent: 'center',
    alignItems: 'center'
}

export const onSubmitLoaderStyle = {
    justifyContent: 'center',
    left: 0,
    right: 0,
    top: '50%',
    position: 'absolute' as 'absolute',
    zIndex: 2
}

export const loginLoaderStyle = {
    justifyContent: 'center',
    left: '20%',
    top: { base: '20%', sm: '25%' },
    position: 'absolute' as 'absolute',
    zIndex: 2
}

export const existingCardDetailsText = {
    textStyle: 'body1',
    paddingLeft: '8px'
}